var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FileBase } from "./FileBase";
import { fileService } from "./FileService";
export class LocalImageFile extends FileBase {
    constructor(fileId, url) {
        super(fileId);
        this.url = url;
        fileService.registerUrl(this.fileId, this.url);
    }
    getData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.url)
                return undefined;
            if (!this.data) {
                this.data = yield fileService.imageToBlob(this.url);
            }
            return this.data;
        });
    }
}
